<sc-flex vertical stretchContent [formGroup]="formGroup" [gap]="16">
  <sc-checkbox-field formControlName="train"
    labelDictionaryKey="tmc-yard.entity.transport.transport-scope.TRAIN"></sc-checkbox-field>
  <sc-checkbox-field formControlName="trailer"
    labelDictionaryKey="tmc-yard.entity.transport.transport-scope.TRAILER"></sc-checkbox-field>
  <sc-checkbox-field formControlName="swapTrailer"
    labelDictionaryKey="tmc-yard.entity.transport.transport-scope.SWAP_TRAILER"></sc-checkbox-field>
  <sc-checkbox-field formControlName="semiTrailerTruck"
    labelDictionaryKey="tmc-yard.entity.transport.transport-scope.SEMI_TRAILER_TRUCK"></sc-checkbox-field>
</sc-flex>
